import React from 'react';

type ContentProps = {
    children?: React.ReactNode | null,
}

export const Wrapper = ({ children }: ContentProps) => (
    <div className="flex flex-col gap-8 w-full max-w-screen-xl mx-auto mt-4 pb-8">
        {children}
    </div>
);
